import React, { Fragment, useCallback } from 'react';
import { connect } from 'react-redux';

// Components
import {
  Element,
  FontType,
  Color,
  Breakpoint,
  Box,
  Button,
  Typography
} from '@americanexpress/aqx-components';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import LazyLoad from 'src/universal/components/DTM/LazyScrollMetricTracker';

// Selectors
import { getPageFeatureFlags } from 'src/universal/redux/page';
import {
  isGCSMember,
  hasMemberInfoArrived
} from 'src/universal/redux/cardMemberInfo';

// Utils
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';
import {
  sendDTMClickEvent,
  mapUrlWithDtmLinkQuery
} from 'service_modules/models/dtm-tagging';

// Styles

import styles from './__styles__/index.scss?modules';

const Banner = ({
  header,
  description,
  imageUrl,
  buttons,
  dtmEvents,
  showBanner
}) => {
  if (!Array.isArray(buttons) || buttons.length === 0 || !showBanner) {
    return null;
  }
  const { impression, click } = parseArrayToObject(dtmEvents, 'tag');
  const { linknav } = parseArrayToObject(dtmEvents, 'type');
  const { url, title, text } = buttons[0];
  const onClick = useCallback(
    () => {
      sendDTMClickEvent(click);
      const urlWithLinkNav = mapUrlWithDtmLinkQuery(url, linknav);
      window.open(urlWithLinkNav, '_blank').focus();
    },
    [click, url]
  );
  return (
    <Fragment>
      <LazyScrollMetricTracker
        startTrackingAfterPznArrival={true}
        scrollDtm={impression}
      />
      <Breakpoint>
        {({ lg }) => (
          <Box className={styles.outerContainer}>
            <Element className={styles.leftCol}>
              <Typography
                Component="h2"
                className={styles.header}
                $family={FontType.BentonBold}
                $size="30px"
                $lineHeight="38px"
                theme={{
                  color: Color.Black,
                  textAlign: lg ? 'left' : 'center',
                  marginBottom: 20
                }}
              >
                {header}
              </Typography>
              <Typography
                $family={FontType.HelveticaRegular}
                $size="20px"
                $lineHeight="28px"
                theme={{
                  color: Color.Black,
                  textAlign: lg ? 'left' : 'center',
                  marginBottom: lg ? 30 : 25
                }}
              >
                {description}
              </Typography>
              <LazyLoad>
                <Element
                  className={styles.image}
                  Component="img"
                  src={imageUrl}
                  alt="Kabbage American Express"
                />
              </LazyLoad>
            </Element>
            <Element className={styles.buttonContainer}>
              <Button
                onClick={onClick}
                title={title}
                theme={{ horizontallyFluid: true }}
              >
                {text}
              </Button>
            </Element>
          </Box>
        )}
      </Breakpoint>
    </Fragment>
  );
};

const mapStateToProps = (state, ownProps) => {
  const pageData = ownProps.pageData;
  const isInTargetAudience = hasMemberInfoArrived(state) && !isGCSMember(state);
  return {
    ...(pageData.kabbageLocBanner || {}),
    showBanner:
      getPageFeatureFlags(state)['showVacKabbageBanner'] && isInTargetAudience
  };
};

export default connect(mapStateToProps)(Banner);
